import { useNavigate } from "react-router-dom";
import { BRAND } from "../../types";

export function OrderHeader() {
  const navigate = useNavigate();

  return (
    <div
      className="sticky top-0 z-50 overflow-hidden"
      style={{
        background:
          "linear-gradient(145deg,#1A1A2E 0%,#16213E 60%,#0F3460 100%)",
      }}
    >
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute rounded-full"
          style={{
            width: 140,
            height: 140,
            top: -20,
            right: -10,
            background: "rgba(255,107,53,0.1)",
            filter: "blur(28px)",
          }}
        />
      </div>
      <div className="relative px-5 pb-5" style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 48px)" }}>
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer flex-shrink-0"
            style={{
              background: "rgba(255,255,255,0.1)",
              border: "1px solid rgba(255,255,255,0.15)",
            }}
          >
            <i
              className="ri-arrow-left-line"
              style={{ fontSize: 18, color: "#fff" }}
            />
          </button>
          <div className="flex items-center gap-2 flex-1">
            <div
              className="w-7 h-7 rounded-lg flex items-center justify-center"
              style={{
                background: "linear-gradient(135deg,#FF6B35,#FF9A5C)",
              }}
            >
              <i
                className="ri-file-list-3-line text-white"
                style={{ fontSize: 13 }}
              />
            </div>
            <div>
              <div className="text-sm font-bold text-white leading-tight">
                填写订单
              </div>
              <div
                className="text-xs leading-tight"
                style={{ color: "rgba(255,255,255,0.45)" }}
              >
                美伊旅行
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
